import React from 'react';
import styled from 'styled-components';
import { BlackBgRoundButton, RoundedButton } from 'components/button';
import { useForm } from 'react-hook-form';
import { COLOR } from 'constants/colors';
import { useDispatch } from 'react-redux';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode } from '__utils/storage';
import { useMediaQuery } from 'react-responsive';
import useFlashToggler from 'hooks/use-flash-toggler';
import { CommonStyledComponentProps } from '__utils/type';
import SmallPopup from 'components/popup/small-popup';
import { MobileInputBox, NameInputBox } from 'components/common-components';
import { setShareCalculatorCustomerDetails } from './investment-calculator.actions';
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import resolveURLParams from '__utils/url-params-resolver';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import GreaterIcon from 'assets/icons/greater-than-icon';
import { capitalizeString } from '__utils/common-utils';


const CustomerOuterCont = styled.div<CommonStyledComponentProps>`
    .shareTitle{
        margin-bottom: 16px;
        h3{
            font-size: ${(props: any) => props.isMobile ? '18px' : '20px'}; 
            margin-bottom: 14px;
        }
        p{
            font-size: ${(props: any) => props.isMobile ? '14px' : '16px'}; 
        }
    }
    .greyLabel{
        color: #4D5556;
    }
`;

const SkipButton = styled(RoundedButton) <CommonStyledComponentProps>`
    color: ${COLOR.BLACK};
    background-color: ${COLOR.WHITE};
    border: 1.5px solid ${COLOR.BLACK};
    &:hover,
    &:focus,
    &:active {
        color: ${COLOR.BLACK};
        background-color: ${COLOR.WHITE};
        border: 1.5px solid ${COLOR.BLACK};
    }
    &:disabled {
        background: ${COLOR.LIGHTGREY} !important;
        cursor: default;
        color: #9e9e9e;;
    }
`;
const ButtonContainer = styled.div`
    text-align: center;
    button{
        width: 200px;
    }
`

interface ShareResultProps {
    onClosePopup: Function
}

const ShareCalculatorPopup: React.FC<ShareResultProps> = ({ onClosePopup }: ShareResultProps) => {

    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();

    const { handleSubmit, control, formState, getValues } = useForm({
        mode: 'all', defaultValues: {
            clientName: '',
            primaryMobile: '',
            primaryEmail: '',
        }
    });
    const { errors } = formState;

    const onShareCalcSubmit = (data: any) => {
        
        Mixpanel.track(getEventName("shareCalculatorButton", "clicked", "calculator"));

        if (data?.clientName && data?.clientMobile) {
            const shareData ={...data,
                clientName: capitalizeString(data.clientName.trim())
            }  

            post(resolveURLParams(ENDPOINTS.POST_SAVE_INTERESTED_CUSTOMER_DETAILS, {}, {}), { userName: shareData?.clientName, mobile: data?.clientMobile, agentCode: getAgentCode(),sendNotification: false }, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {  

                if (response.response?.meta?.error) {
                    flash.error(response.response?.meta?.error);
                }
                else dispatch(setShareCalculatorCustomerDetails(shareData, true));

            }, (error: AjaxError) => {
                flash.error("Something went wrong. Please try again later")
            });
        }
        else  dispatch(setShareCalculatorCustomerDetails(data, true));
    }

    const ShareCustomerContent = () => {
        return (<CustomerOuterCont isMobile={isMobile}>
            <div className='shareTitle'>
                <h3>Enter Customer Details</h3>
                <p>You can make the calculator results personalised by adding customer name & number</p>
            </div>
            <form name="createLeadForm" onSubmit={handleSubmit(onShareCalcSubmit)} noValidate>
                <NameInputBox
                    name="clientName"
                    id="clientName"
                    control={control}
                    placeholder="Enter Customer Name"
                    errors={errors}
                    rules={{
                        validate: {
                            required: value => {
                                if (!value && getValues('clientMobile')) return 'Customer name is mandatory';
                                return true;
                            },
                        }
                    }}
                    inputLabel={<p className="greyLabel">Customer Name (Optional)</p>}
                />
                <MobileInputBox
                    name="clientMobile"
                    id="clientMobile"
                    placeholder="Enter Customer Number"
                    control={control}
                    rules={{
                        validate: {
                            required: value => {
                                if (!value && getValues('clientName')) return 'Customer mobile number is mandatory';
                                return true;
                            },
                        }
                    }}
                    errors={errors}
                    inputLabel={<p className="greyLabel">Customer Number (Optional)</p>}
                />
                <br />
                <ButtonContainer>
                    <BlackBgRoundButton type="submit">Share  &nbsp;<GreaterIcon color={COLOR.WHITE} /></BlackBgRoundButton>
                </ButtonContainer>
            </form>

        </CustomerOuterCont >);
    }

    return (
        <SmallPopup content={ShareCustomerContent()} closable={true} onClose={() => onClosePopup()}> </SmallPopup>
    );
}

export default ShareCalculatorPopup;